import React from 'react';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ManageDeliverySlotsComponent from '@app/components/manage-delivery-slots/list';

const ManageDeliverySlots: React.FC = () => {
  return (
    <>
      <PageTitle>Delivery Slots</PageTitle>
      <ManageDeliverySlotsComponent />
    </>
  );
};

export default ManageDeliverySlots;
